import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-button',
  imports: [
    CommonModule,
  ],
  templateUrl: './button.component.html',
  standalone: true,
  styleUrl: './button.component.css'
})
export class ButtonComponent {
  @Input() loading: boolean = false; // show spinner
  @Input() spinnerClass: string = 'h-3 w-3 animate-spin'; // customize spinner style
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() customClass: string = '';
  @Input() disabled: boolean = false;
  @Input() iconSrc?: string; // optional icon
  @Input() iconAlt: string = 'icon';
  @Input() iconClass: string = ''; // optional class for icon
  @Input() iconWhite: boolean = false; // when true, applies filter so black icon appears white on dark bg
  @Input() textClass: string = '';

  @Output() clicked = new EventEmitter<Event>();

  onClick(event: Event) {
    if (!this.disabled) {
      this.clicked.emit(event);
    }
  }

  get buttonClasses(): string {
    return `btn ${this.customClass}`;
  }
  get textClasses(): string {
    return `btn ${this.textClass}`;
  }
}
